import { ComponentType, PropsWithChildren } from 'react';
import type { AppointmentType } from '@frontend/api-appointment-types';
import { PersonTypes } from '@frontend/api-person';
import { ModalControlResponse } from '@frontend/design-system';
import { ReducedAppointmentType } from '../hooks/useReviewRequest';

export type CreateAppointmentRequestParamsType = {
  selectedPerson: PersonTypes.Person | null;
  selectedProviderId: string;
  selectedApptType: AppointmentType | ReducedAppointmentType | undefined;
  selectedWorkstationId: string | undefined;
  startDate: string;
  sourceId: string;
  selectedProviderName: string;
  appointmentDuration: number;
};

export type CreateWritebackAppointmentV3PayloadArgs = {
  selectedPerson: PersonTypes.Person;
  selectedApptType: ReducedAppointmentType | undefined;
  selectedProviderId: string;
  selectedWorkstationId: string | undefined;
  startDate: string;
  sourceId: string;
  selectedProviderName: string;
  appointmentDuration: number;
};

export enum ScheduleRequestModalTypeEnum {
  WRITEBACK_ERROR = 'WRITEBACK_ERROR',
  MESSAGE_SENT = 'MESSAGE_SENT',
  ERROR = 'ERROR',
  MESSAGE_ERROR = 'MESSAGE_ERROR',
  NO_WRITEBACKS_ERROR = 'NO_WRITEBACKS_ERROR',
  NO_WRITEBACKS_MESSAGE_SENT = 'NO_WRITEBACKS_MESSAGE_SENT',
}

export type SourceTenantListItem = {
  sourceTenantId?: string;
  parentSourceTenantId?: string;
  sourceId?: string;
  name?: string;
  pmsName?: string;
};

// For workstation dropdown item list (v2 uses type 'Workstation' and v3 uses type 'ReducedOperatory')
export type WorkstationDropdownList<T> = {
  available: T[];
  all: T[];
};

export type ScheduleRequestContentWrapper = ComponentType<
  PropsWithChildren<{ onClose: () => void; modalProps: ModalControlResponse }>
> & {
  Header: ComponentType<PropsWithChildren<{ onClose: () => void }>>;
  Content: ComponentType<{ children: React.ReactNode }>;
};
